<template>
    <div class="container mb-3" v-if="additionalQuestion && selectedServiceGroupId">    
        <h6 class="font-weight-bold" v-if="additionalQuestion.question">{{ additionalQuestion.question }}</h6>
        <div class="ml-3">
            <!-- Additional Question 1 -->
            <div class="d-flex align-items-center"
                v-if="
                    additionalQuestion.response_1 &&
                    additionalQuestion.response_1 != '' &&
                    additionalQuestion.comment_1
                ">
                <div class="form-check">
                    <input  
                        v-model="selected"
                        type="radio" 
                        name="additionalQuestionChoice" 
                        id="additionalQuestion1"
                        :value="additionalQuestion.comment_1"
                    />
                    <label
                        class="form-check-label"
                        for="additionalQuestion1"
                        tabindex="0"
                        @keydown="event => { selectedOptionTermsKeyEvent(event, additionalQuestion.comment_1) }">
                        {{ additionalQuestion.response_1 }}
                    </label>
                </div>
                <div
                    v-if="additionalQuestion.label_1 && additionalQuestion.label_1 != ''"
                    class="d-block d-sm-inline-block text-warning text-underlined pl-lg-2 ml-4"
                >
                    <p
                        class="text-tru-orange cursor-pointer paragraph-reduced text-link-blue m-0"
                        v-html="additionalQuestion.label_1"
                        @click="() => toggleAdditionalInfo(1)"></p>
                </div>
            </div>

            <!-- Additional Info 1 -->
            <div class="row pt-3 pb-3" v-if="displayInfo == 1 && additionalQuestion.info_1 && additionalQuestion.info_1 != ''">
                <div class="col-lg-12">
                    <div
                    class="bundle-greenwaste-note border rounded d-block p-3"
                    v-html="additionalQuestion.info_1"></div>
                </div>
            </div>

            <!-- Additional Question 2 -->
            <div class="d-flex align-items-center"
                v-if="
                    additionalQuestion.response_2 &&
                    additionalQuestion.response_2 != '' &&
                    additionalQuestion.comment_2
                ">
                <div class="form-check">
                    <input  
                        v-model="selected"
                        type="radio" 
                        name="additionalQuestionChoice" 
                        id="additionalQuestion2"
                        :value="additionalQuestion.comment_2"
                        />
                    <label
                        class="form-check-label"
                        for="additionalQuestion2"
                        tabindex="0"
                        @keydown="event => { selectedOptionTermsKeyEvent(event, additionalQuestion.comment_2) }">
                        {{ additionalQuestion.response_2 }}
                    </label>
                </div>
                <div
                    v-if="additionalQuestion.label_2 && additionalQuestion.label_2 != ''"
                    class="d-block d-sm-inline-block text-warning text-underlined pl-lg-2 ml-4"
                >
                    <p
                        class="text-tru-orange cursor-pointer paragraph-reduced text-link-blue m-0"
                        v-html="additionalQuestion.label_2"
                        @click="() => toggleAdditionalInfo(2)"></p>
                </div>
            </div>

            <!-- Additional Info 1 -->
            <div class="row pt-3 pb-3" v-if="displayInfo == 2 && additionalQuestion.info_2 && additionalQuestion.info_2 != ''">
                <div class="col-lg-12">
                    <div
                    class="bundle-greenwaste-note border rounded d-block p-3"
                    v-html="additionalQuestion.info_2"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GeneralBookingSettingMixin from '../../../../common/mixins/GeneralBookingSettingMixin';
import Texts from '../../../../common/utils/Texts'

export default {
    mixins: [GeneralBookingSettingMixin],
    props: {
    },
    data() {
        return {
            selected: '',
            displayInfo: null
        }
    },
    computed: {
        TEXTS: () => Texts,
        bookingState : function(){
            return this.$store.getters.GET_BOOKING_STATE
        },
        selectedServiceGroupId () {
            return this.bookingState.selectedServiceGroup
                ? this.bookingState.selectedServiceGroup.service_group_id
                : -1
        },
        userType() {
            return this.$store.getters.GET_PERSONAL_INFO.type;
        },
        additionalQuestion() {
            return this.$store.getters.GET_ADDITIONAL_QUESTIONS
                ? this.$store.getters.GET_ADDITIONAL_QUESTIONS.find(x => x.service_group_id == this.selectedServiceGroupId)
                : null
        }
    },
    mounted() {
        this.$store.dispatch('getAdditionalQuestions')
    },
    methods: {
        toggleAdditionalInfo(value) {
            if(!this.displayInfo || this.displayInfo != value) {
                this.displayInfo = value
            } else {
                this.displayInfo = null
            }
        }
    },
    watch: {
        selected(val) {
            if(val == this.additionalQuestion.comment_1) {
                this.displayInfo = 1
            } else {
                this.displayInfo = 2
            }
            this.$store.dispatch('setBookingState', {...this.bookingState, additionalQuestion: val});
        }
    }
}
</script>